/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { EvmDailyCountInfo } from './EvmDailyCountInfo';

export type EvmHomeDailyAccountCreatedInfo = {
    PTCACNT: string;
    CNGP: string;
    TRXHTP: EvmHomeDailyAccountCreatedInfo.TRXHTP;
    DCALIST: Array<EvmDailyCountInfo>;
};

export namespace EvmHomeDailyAccountCreatedInfo {

    export enum TRXHTP {
        DAY = 'DAY',
        WEEK = 'WEEK',
        MONTH = 'MONTH',
        QUARTER = 'QUARTER',
    }


}

